import React from "react";
import { FIELDS } from "../../../../constants/PostFormFields";
import { useFlushPending } from "../platform-fields/flush-registry";
import { SwitchFieldRow } from "./SwitchFieldRow/SwitchFieldRow";
import { useStoryCapability } from "../utils/story-platforms";
import { isFbStoryPromoLive } from "../FbStoryPromo/fb-story-promo";
import { NewPillMark } from "../FbStoryPromo/NewPillMark";

export function SwitchIsStoryOrNotification({
  selectedPlatform,
  postFormValue,
  updateField,
  allDisabled,
  platforms,
}) {
  const flushPending = useFlushPending();
  const { label, badges } = useStoryCapability(platforms);
  const sharedTabOnly =
    selectedPlatform !== "LINKED" && (!platforms || platforms.length > 1);
  return (
    <SwitchFieldRow
      className="mb-3"
      data-testid="ig-story-switch"
      label={label}
      checked={postFormValue.isStory === true}
      selectedPlatform={selectedPlatform}
      platforms={badges}
      trailing={isFbStoryPromoLive() ? <NewPillMark /> : null}
      info={
        sharedTabOnly && !allDisabled
          ? {
              label: "Why Story is set on the shared tab",
              content:
                "A story applies to every channel. Turn it off on the shared tab.",
            }
          : undefined
      }
      onCheckedChange={() => {
        // Toggling Story remounts field editors; flush in-flight edits first.
        flushPending();
        updateField(FIELDS.IS_STORY, !postFormValue.isStory);
        updateField(FIELDS.PUBLISH_STORY_MANUALLY);
      }}
      // A story is post-wide, so a multi-channel post toggles it on the shared
      // tab only. A channel tab would write it into that channel's override.
      disabled={allDisabled || sharedTabOnly}
    />
  );
}
